<template>
    <div class="notice">
      <div class="content" v-if="noticeData.content || noticeData.link">
          <p class="time">{{ transformTime(Date.now()) }}</p>
          <!-- <span>{{noticeData.content}}</span> -->
          <span v-html="changeContent()"></span>
          <a
            v-if="noticeData.link"
            :href="noticeData.link"
            target="_blank"
          >{{noticeData.link}}</a>
      </div>
      <div class="noNotice" v-else>
        <img src="@/assets/img/live/noNotic.png" alt="">
        暂无公告
      </div>
    </div>
</template>

<script>
import { dateTime } from '../../../utils/tools';
// eslint-disable-next-line
const { eventEmitter } = BJY;
export default {
  name: 'notice',
  data() {
    return {
      noticeData: {},
      namespace: `.live${Math.random()}`,

    };
  },
  created() {
    eventEmitter
      .on(
        eventEmitter.NOTICE_RES + this.namespace,
        (e, data) => {
          this.noticeData = data;
        },
      )
      .on(
        eventEmitter.NOTICE_CHANGE + this.namespace,
        (e, data) => {
          this.noticeData = data;
        },
      );
    // // 向服务器拉取最新的公告
    eventEmitter.trigger(
      eventEmitter.NOTICE_REQ,
      eventEmitter.NOTICE_CHANGE_TRIGGER,
    );
  },
  methods: {
    transformTime(time) {
      const t = dateTime(time);
      return `${t.year}-${t.month}-${t.day} ${t.h}:${t.m}`;
    },
    changeContent() {
      const { content } = this.noticeData;
      let msg = '';
      /* eslint-disable */
      $.each(content.split(' '), (i, n) => {
        n = $.trim(n);
        msg += `${this.ReplaceUrl(n)} `;
      });
      return msg;
    },
    ReplaceUrl(text) {
      // eslint-disable-next-line no-useless-escape
      const re = /(http[s]?:\/\/([\w-]+.)+([:\d+])?(\/[\w-\.\/\?%&=]*)?)/gi;
      const s = text.replace(re, (u) => `<a target="_blank" style="color: #0091FF" href="${u}" target=_blank>${u}</a>`);
      return s;
    },
  },
};
</script>
<style lang="scss" scoped>
 .notice {
   width: 92%;
   max-height: 100%;
   margin: 20px auto;
   padding:24px 40px;
   overflow-y: auto;
   word-wrap:break-word;
   background: #fff;
   border-radius: 8px;
   .time {
     margin-bottom: 8px;
     color: #787878;
     font-size: 25px;
   }
   span {
     color: #333;
     font-size: 28px;
     line-height: 34px;
   }
   a {
    color: #0091FF;
    font-size: 28px;
    line-height: 34px;
   }
   .noNotice {
     display: flex;
     flex-direction: column;
     align-items: center;
     padding: 40px 0;
     color: #333;
     color: #787878;
     font-size: 28px;
     img {
       width: 50%;
     }
   }
  }
</style>
